import KioskPerimeter from './KioskPerimeter'

export default KioskPerimeter
